import React from 'react';
import { Alert } from '@mui/material';

export function CustomerBankInfo({ customer, labelPrefix, sx }) {
  if (!customer?.bank) return null;
  const { bank_name: bankName, account_name: accountName, account_number: accountNumber, branch } = customer.bank;

  return (
    <Alert severity="info" sx={sx}>
      {labelPrefix}
      ธนาคาร: {bankName || '-'} /
      {' '}ชื่อบัญชี: {accountName || '-'} /
      {' '}เลขบัญชี: {accountNumber || '-'} /
      {' '}สาขา: {branch || '-'}
    </Alert>
  );
}

export default CustomerBankInfo;
